/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation026.less';

interface IAnimation026Item {
  text: string;
  title: string;
  color: string;
}

interface IAnimation026Props {
  items: IAnimation026Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation026: React.FunctionComponent<IAnimation026Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };

  return (
    <div className={`animation026 component ${className || ''}`}>
      {items.map((itm: IAnimation026Item, idx: number) => (
        <>
          <div
            key={idx}
            className={`animation026-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation026-rectangle-div"
              style={{ backgroundColor: itm.color }}
            >
              <div
                className="animation026-title"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
              <div
                className="animation026-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default Animation026;
